<template>
    <v-dialog :persistent="persistent" :value="value" max-width="700px" @keydown.esc.prevent="cancel">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <span v-if="context">&nbsp;({{ context }})</span>
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-container>
                        <v-row dense>
                            <v-col cols="12">
                                <div v-html="message"></div>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="response"
                                    v-bind="{ rules: responseRequired ? getRules('required') : [] }"
                                    dense
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <slot name="actions">
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
                    <v-btn :disabled="!valid" color="action" text @click="confirm">{{ confirmLabel }}</v-btn>
                    <v-btn
                        v-if="confirmAlternateLabel"
                        :disabled="!valid"
                        color="action"
                        text
                        @click="confirmAlternate"
                        >{{ confirmAlternateLabel }}</v-btn
                    >
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getI18nInstance as i18n } from '@/i18n';
import getRulesMixin from '@/mixins/get-form-rules';

export default {
    name: 'PromptDialog',
    mixins: [getRulesMixin],

    props: {
        title: {
            type: String,
            default: () => i18n().t('confirm'),
        },
        message: {
            type: String,
            default: () => i18n().t('confirm_msg'),
        },
        // context is the additional text to be displayed in the confirm message,
        // e.g. "Delete (<context>)" --> "Delete (user x)"
        context: {
            type: String,
            default: null,
        },
        persistent: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Boolean,
            required: true,
        },
        responseRequired: {
            type: Boolean,
            default: true,
        },
        confirmLabel: {
            type: String,
            default: () => i18n().t('confirm').toLowerCase(),
        },
        confirmAlternateLabel: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            response: null,
            valid: null,
        };
    },

    mounted() {
        this.validateForm();
    },

    methods: {
        validateForm() {
            this.$refs.form.validate();
        },

        cancel() {
            this.$emit('cancel');
            this.$emit('input', false);
        },

        confirm() {
            this.$emit('confirm', this.response);
            this.$emit('input', false);
        },

        confirmAlternate() {
            this.$emit('confirm-alternate', this.response);
            this.$emit('input', false);
        },
    },
};
</script>
